import SmartTargetModal from './SmartTargetModal'

export default SmartTargetModal